// The group control of a string (the grid's inline select and the drawer's field, section 9.1): the existing groups plus
// "New group…", which turns into a name field (a group exists through its strings).
import { useState } from 'react';
import { CellTextEditor } from '../../content/localization/CellTextEditor';
import { validName } from '../../content/localization/strings';
import { Select } from '../../ui/inputs';

const NEW = '\u0000new';

export function GroupPicker({ value, groups, onCommit, onCancel, autoFocus, disabled, 'aria-label': ariaLabel = 'Group' }: { value: string; groups: string[]; onCommit: (group: string) => void; onCancel?: () => void; autoFocus?: boolean; disabled?: boolean; 'aria-label'?: string }) {
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const options = Array.from(new Set([...groups, value].filter(Boolean))).sort();
  if (creating) {
    return (
      <span className="loc-group-new">
        <CellTextEditor
          value=""
          autoFocus
          placeholder="NEW_GROUP"
          aria-label="New group name"
          invalid={!!error}
          onCommit={(text) => {
            const problem = validName(text);
            if (problem) {
              setError(problem);
              return;
            }
            setError(null);
            setCreating(false);
            onCommit(text);
          }}
          onCancel={() => {
            setCreating(false);
            setError(null);
            onCancel?.();
          }}
        />
        {error && <span className="field-error">{error}</span>}
      </span>
    );
  }
  return (
    <Select
      size="s"
      value={value}
      autoFocus={autoFocus}
      disabled={disabled}
      aria-label={ariaLabel}
      onChange={(e) => {
        if (e.target.value === NEW) setCreating(true);
        else onCommit(e.target.value);
      }}
      onBlur={() => onCancel?.()}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onCancel?.();
      }}
    >
      {options.map((g) => (
        <option key={g} value={g}>
          {g}
        </option>
      ))}
      <option value={NEW}>New group…</option>
    </Select>
  );
}
